var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitInBulk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.52 36.89H8.91c-2.62 0-4.77-2.15-4.77-4.77V14.9c0-2.62 2.15-4.77 4.77-4.77h12.54c2.62 0 4.77 2.15 4.77 4.77v9.69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.91 5.58a4.526 4.526 0 013.54-1.71h11.02c2.5 0 4.54 2.04 4.54 4.54v10.12M21.26 38.77c0-5.08 4.16-9.24 9.24-9.24h8.14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M32.62 23.51l6.02 6.02-6.02 6.03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.18 21.95h9.88M15.02 15.98h5.04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_dot",
    d: "M11.67 15.98c0 .81-.66 1.47-1.47 1.47-.81 0-1.47-.66-1.47-1.47 0-.81.66-1.47 1.47-1.47.81 0 1.47.66 1.47 1.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitInBulk);
export default __webpack_public_path__ + "static/media/submitInBulk.90784be8721e601d3c6a95e7354491c3.svg";
export { ForwardRef as ReactComponent };